import { FC } from 'react';
import { Button } from '@cb/apricot-react';
import { useNavigate } from "react-router-dom";
import { APP_URLS } from 'src/constants';
import { flush } from 'src/services/schoolRequest';
import { useType } from 'src/contexts';
import './styles.css'



const Landing: FC = () => {
  const navigate = useNavigate();
  const {setType} = useType();
  return <>
    <div>
      <h5 style={{ textAlign: "center" }}>Please select which type of requests you'd like to view:</h5>
      <br />
      <br />
      <div>
        <Button className="landing-button" onClick={() => { flush();setType('ai'); navigate(APP_URLS.HOME, { state: { type: 'ai' } }) }}>School Code (K-12)</Button>
      </div>
      <br />
      <div>
        <Button className="landing-button" onClick={() => { flush();setType('di') ;navigate(APP_URLS.DIHOME, { state: { type: 'di' } }) }}>Score Send Code (Post-Secondary)</Button>
      </div>
      <br />
      <div>
        <Button className="landing-button" onClick={() => { navigate(APP_URLS.REPORTS) }}>Reports</Button>
      </div>
    </div>
  </>
};

export default Landing;
